// extracted by mini-css-extract-plugin
module.exports = {"title":"Price_title__2oA2W","price":"Price_price__1jh-d"};